'use client';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNavSize,
  CarouselNext,
  CarouselPrevious,
} from '@vs-shop/ui/carousel';
import Autoplay from 'embla-carousel-autoplay';

import { HEUREKA_REVIEWS_HOMEPAGE_DELAY_MILLIS } from '../../../../config/banner';

import HeurekaReview from '../../../server/page/homepage/HomepageCustomerCompanyReview';

import type { HomepageHeurekaReview } from '../../../../effect/schema/openapi/backend';

type Props = {
  heurekaReviews: readonly HomepageHeurekaReview[];
};

export default function HomepageHeurekaReviewsCarousel({ heurekaReviews }: Props) {
  return (
    <Carousel
      plugins={[Autoplay({ delay: HEUREKA_REVIEWS_HOMEPAGE_DELAY_MILLIS })]}
      className="grid gap-25"
      data-slot="homepage-heureka-carousel"
    >
      <CarouselContent className="-ml-0">
        {heurekaReviews.map((heurekaReview) => (
          <CarouselItem
            key={heurekaReview.ratingId}
            className="w-[300px] basis-auto pl-6 lap:w-[400px]"
          >
            <HeurekaReview heurekaReview={heurekaReview} />
          </CarouselItem>
        ))}
      </CarouselContent>

      <div className="flex justify-center gap-4">
        <CarouselPrevious
          navSize={CarouselNavSize.RESPONSIVE}
          variant="ghostInverted"
          position="free"
        />
        <CarouselNext
          navSize={CarouselNavSize.RESPONSIVE}
          variant="ghostInverted"
          position="free"
        />
      </div>
    </Carousel>
  );
}
